import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "col-12 border rounded mb-3 bg-white"
};
const _hoisted_2 = { class: "row" };
const _hoisted_3 = {
    class: "col-sm-8 col-10 text-center border-right overflow-hidden py-2",
    style: { "hyphens": "auto" }
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "font6 mt-1" };
const _hoisted_6 = { class: "font2 strong my-2" };
const _hoisted_7 = {
    key: 0,
    class: "font5"
};
const _hoisted_8 = { key: 1 };
const _hoisted_9 = { class: "input-group mycode" };
const _hoisted_10 = ["value"];
const _hoisted_11 = {
    class: "input-group-append",
    style: { "margin-left": "0" }
};
const _hoisted_12 = { class: "font7 mt-4 text-left" };
const _hoisted_13 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_formatted_date = _resolveComponent("formatted-date");
    return (_ctx.coupon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.coupon.description)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "font7 mt-0",
                            innerHTML: _ctx.coupon.description
                        }, null, 8, _hoisted_4))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.coupon.title), 1),
                    _createElementVNode("div", _hoisted_6, [
                        (_ctx.isShipping)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Kostenloser Versand"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createTextVNode(_toDisplayString(_ctx.formatedValue) + " ", 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.isFixed ? '€' : _ctx.isPercent ? '%' : ''), 1)
                            ]))
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("div", null, "Code:", -1)),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("input", {
                            type: "text",
                            class: "form-control text-center",
                            ref: "code",
                            readonly: true,
                            value: _ctx.coupon.code
                        }, null, 8, _hoisted_10),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                                class: _normalizeClass(["btn js-tooltip btn-outline-secondary", { 'bg-success icon-checked': _ctx.isCurrentCode }]),
                                type: "button",
                                "data-toggle": "tooltip",
                                "data-placement": "bottom",
                                "data-original-title": "Gutscheincode kopieren",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.applyCode && _ctx.applyCode(...args)))
                            }, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("i", { class: "icon-clone" }, null, -1)
                                ]))], 2)
                        ])
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "barcode mt-2 text-center" }, [
                        _createElementVNode("img", {
                            src: "/images/barcodeVoucher.png",
                            alt: "Bar Code Gutschein",
                            style: { "width": "80%", "height": "auto" }
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_12, [
                        _cache[2] || (_cache[2] = _createTextVNode(" Gültig bis: ", -1)),
                        _createElementVNode("span", null, [
                            _createVNode(_component_formatted_date, {
                                date: _ctx.coupon.expire_date
                            }, null, 8, ["date"])
                        ])
                    ])
                ]),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-sm-4 col-2 pr-0 coupon-background", _ctx.coupon.type])
                }, [
                    _createElementVNode("img", {
                        src: _ctx.coupon.image,
                        class: "d-sm-block d-none",
                        alt: "Gutschein",
                        style: { "width": "100%", "height": "100%", "object-fit": "contain", "object-position": "right bottom" }
                    }, null, 8, _hoisted_13)
                ], 2)
            ])
        ]))
        : _createCommentVNode("", true);
}
